import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../service/base.service';
import { CountryService } from '../service/country.service';



@Injectable({
    providedIn: 'root'
})
export class CountryResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: CountryService,
        private baseService: BaseService
    ) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
        return this.baseService.resolveGet(this.service, route, '/page/companies');
    }
}

@Injectable({
    providedIn: 'root'
})
export class CountriesResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: CountryService,
        private baseService: BaseService
    ) { }
    resolve(): Observable<ApiObjectData> {

        return this.baseService.resolveGets(this.service);
    }
}
